import { noOp } from '../common/';
import { isNotBlank } from './dataUtils';
import { isFunction, isPresent } from './typeUtils';

export const isClient = (): boolean => typeof window !== 'undefined';
export const isServer = (): boolean => !isClient();

export const mediaQuery = (media: string, matchesByDefault: boolean): MediaQueryList => {
  if (isServer() || !isFunction(window.matchMedia)) {
    return { matches: matchesByDefault, media, addListener: noOp } as any as MediaQueryList;
  }
  return window.matchMedia(media);
};

export const isDevEnv = (): boolean => process.env.NODE_ENV === 'development';

export const asCmsLang = (locale = ''): string => {
  const [lang, country] = locale.toLowerCase().split('_');
  // TODO: HK needs special handling?
  return isPresent(country) ? `${country}-${lang}` : lang;
};

export interface CountryAndLang {
  country: string;
  lang: string;
}
export const asCountryAndLang = (locale = ''): CountryAndLang => {
  const [lang, country] = locale.toUpperCase().split('_');
  // TODO: HK needs special handling?
  return { lang, country: isNotBlank(country) ? country : lang };
};
